/**
 * Cuts at `limit` UTF-16 code units, backing off by one if that would split a
 * surrogate pair and leave a lone surrogate (which re-encodes to U+FFFD).
 */
export function sliceAtCodePoint(text: string, limit: number): string {
  const cutSplitsCharacter = (text.codePointAt(limit - 1) ?? 0) > 0xffff;
  return text.slice(0, cutSplitsCharacter ? limit - 1 : limit);
}
